import { TITLE } from "@config";

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle}`;
  }
  return `${$t('首页')}-${TITLE}`;
}
